import React from 'react';
import {
    DialogModal,
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'components';
import BankIdCompleted from './bank-id-completed';
import BankIdInProgress from './bank-id-in-progress';
import BankIdErrorMessage from './bank-id-error-message';
import BankIdStart from './bank-id-start';
import FooterActions from './footer-actions';
import ModalState from 'tradera-state/bank-id/modal-state';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as bankIdActions from 'tradera-state/bank-id/actions';
import { withTranslator } from 'static/script/app/lang';

class BankIdModal extends React.Component {
    static defaultProps = {
        bankIdReasonText: null
    };

    static propTypes = {
        bankIdReasonText: PropTypes.string
    };

    render() {
        const {
            bankIdReasonText,
            cancelBankId,
            startBankIdAuthentication,
            modalState,
            errorMessage,
            isAutoStartAllowed,
            autoStartToken,
            closeModal,
            t
        } = this.props;

        const BankIdModalBody = () => {
            switch (modalState) {
                case ModalState.IN_PROGRESS:
                    return (
                        <BankIdInProgress
                            autoStartToken={autoStartToken}
                            isAutoStartAllowed={isAutoStartAllowed}>
                            {bankIdReasonText}
                        </BankIdInProgress>
                    );
                case ModalState.COMPLETED:
                    return <BankIdCompleted />;
                case ModalState.ERROR:
                    return (
                        <BankIdErrorMessage bankIdErrorMessage={errorMessage} />
                    );
                case ModalState.START:
                    return (
                        <BankIdStart
                            autoStartToken={autoStartToken}
                            isAutoStartAllowed={isAutoStartAllowed}>
                            {bankIdReasonText}
                        </BankIdStart>
                    );
                default:
                    return null;
            }
        };

        const onFinish = () => cancelBankId();

        if (modalState === ModalState.CLOSED) {
            return null;
        }
        return (
            <DialogModal className="myt-payments2" onDismiss={closeModal}>
                <ModalContainer
                    className="justify-content-sm-start"
                    onClose={closeModal}>
                    <ModalHeader
                        className="bg-palette-grey-6 border-0"
                        onClose={closeModal}>
                        {t('bankIdModal_verificationStartedTitle')}
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-center align-items-center">
                        <BankIdModalBody />
                    </ModalBody>
                    <ModalFooter>
                        <FooterActions
                            onFinish={onFinish}
                            onClose={closeModal}
                            startBankIdAuthentication={
                                startBankIdAuthentication
                            }
                        />
                    </ModalFooter>
                </ModalContainer>
            </DialogModal>
        );
    }
}

const mapStateToProps = state => {
    const bankId = state.bankId;
    return {
        errorMessage: bankId.errorMessage,
        autoStartToken: bankId.autostartToken,
        modalState: bankId.modalState,
        isAutoStartAllowed: bankId.isAutoStartAllowed
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    closeModal: () => {
        dispatch(bankIdActions.close());
        ownProps.onClose();
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslator(BankIdModal));
